"use client";

import { c as _c } from "react/compiler-runtime";
import { X as CloseIcon, Save as FloppyIcon } from "lucide-react";
import { useSearchParams } from "next/navigation";
import { useState } from "react";
import { useIntl } from "react-intl";
import { TypoText } from "ui/Typo";
import { Button } from "uiShadcn/button";
import { cn } from "utils/helpers/cn";
interface InfoBannerProps {
  children?: React.ReactNode;
  candidateLoaded?: boolean;
}
function InfoBanner(t0) {
  const $ = _c(18);
  const {
    children,
    candidateLoaded
  } = t0;
  const {
    formatMessage
  } = useIntl();
  const [isVisible, setVisibility] = useState(true);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setVisibility(false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const hideBanner = t1;
  const searchParams = useSearchParams();
  const isFilledFromPracujMobile = searchParams.get("filledFromPracujMobile") === "true";
  if (!isVisible || !candidateLoaded && !isFilledFromPracujMobile) {
    return null;
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("flex flex-row items-center bg-banner px-8 py-4 text-background", "transition-all duration-500 ease-in-out");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = !isVisible;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FloppyIcon strokeWidth={1} className="mr-8 h-6 w-6 shrink-0" />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== children) {
    t5 = <TypoText className="grow text-background">{children}</TypoText>;
    $[3] = children;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== formatMessage) {
    t6 = formatMessage({
      id: "close"
    });
    $[5] = formatMessage;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== formatMessage) {
    t7 = formatMessage({
      id: "close"
    });
    $[7] = formatMessage;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = isVisible ? 0 : -1;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <CloseIcon strokeWidth={1} size={16} />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t6 || $[11] !== t7 || $[12] !== t8) {
    t10 = <Button className="shrink-0 self-start" type="button" dataTestId="close-InfoBanner" variant="ghost" size="icon" aria-label={t6} title={t7} onClick={hideBanner} tabIndex={t8}>{t9}</Button>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t3 || $[16] !== t5) {
    t11 = <div id="banner" role="dialog" className={t2} aria-hidden={t3}>{t4}{t5}{t10}</div>;
    $[14] = t10;
    $[15] = t3;
    $[16] = t5;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
}
export default InfoBanner;